import ImageTextRow from "./ImageTextRow"

export default ImageTextRow
